import type { IMonitoring } from "@/application/ports/IMonitoring";
import { getMonitoring } from "@/infrastructure/di/services";

export function useMonitoring(): IMonitoring {
  return getMonitoring();
}
